import { defineComponent as _defineComponent } from 'vue'
import ButtonPrintTicket from '../components/button-print-ticket.vue';  
import ButtonExcel from '../components/button-excel.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ticket-app-title-bar',
  setup(__props) {


return { __sfc: true,ButtonPrintTicket, ButtonExcel }
}

})